export const globalOnClear = (
  setFiltersFunction: (filters: any) => void,
  setPageFunction: (page: number) => void,
  apiCallFunction: (params: any) => void,
  filters: any,
  page: number
) => {
  let { orderBy, orderType, ...newFilter } = filters;
  if (Object.keys(newFilter).length !== 0 || page !== 1) {
    setFiltersFunction({});
    setPageFunction(1);
    apiCallFunction({ page: 1 });
  }
};
